<template>
  <div>
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <div class="filter-box">
          <el-input
            v-model="comment"
            placeholder=" "
            style="width: 400px"
            :size="t('table.btnSize')"
            class="filter-item leaveMessage"
            clearable
          />
        </div>
        <div class="filter-box">
          <!-- <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button> -->
          <el-button
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            留言
          </el-button>
        </div>
      </div>
      <TableList
        ref="TableList"
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :showSelection="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :canCommand="false"
        :page="listQuery.page"
        :size="listQuery.size"
        @command-change="handleCommand"
      >
      </TableList>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElForm } from 'element-plus'
import { getTraceList, traceComment } from '@/apis/Dictionary'

import { CostModel } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Traceinfo',
  components: {
    TableList
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    api: { type: String, required: true, default: '' }
  },
  setup(props) {
    const { t } = useI18n()
    const TableList = ref(null)
    const setForm = ref(ElForm)

    const dataMap = reactive({
      TableName: TableName.TABLE_COSTOMER_TRACE,
      permissionName: permissionName.COSTOMER_TRACE,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        phone: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      submitLoading: false,
      comment: '',

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            ;(TableList.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        if (!props.id) {
          dataMap.list = []
          return
        }
        dataMap.listLoading = true
        getTraceList(props.api, props.id, dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          phone: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        traceComment(props.api, props.id, { comment: dataMap.comment }).then(() => {
          dataMap.getList()
        })
      },

      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      dataMap.getList()
    })
    return { TableList, t, ...toRefs(dataMap), setForm }
  }
})
</script>
